import React, {useState, useEffect,} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import Campo from '../../Components/Campo';
import Header from '../../Components/Header';
import { Spinner  } from "react-awesome-spinners";
import FinderSelect from 'react-finderselect';
import { Web } from '@material-ui/icons';
import { DatePicker, DatePickerInput } from 'rc-datepicker';
import DataTime from '../../Components/TADateFormat';


export default ({ListEsp, setUsuariosContServ, UsuariosContServ,  Dados, Avisando, Fechar, Id, setAlert, setAlertTipo}) => {

const [Titulo, setTitulo] = useState("Vizualizar Ticket Pago");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [Img2, setImg2] = useState("../assets/avatarimg.png");
const [Imgs2, setImgs2] = useState("");
const [Imgs1Res, setImgs1Res] = useState("");
const [Nome, setNome] = useState("");
const [Telefone, setTelefone] = useState("");
const [Mensalidade, setMensalidade] = useState("0000");
const [DiaMes, setDiaMes] = useState("00");
const [DiaMesExt, setDiaMesExt] = useState("00");
const [AtualAno, setAtualAno] = useState("0000"); 
const [QuantApp, setQuantApp] = useState("0000");
const [ValorApp, setValorApp] = useState("0000");
const [End, setEnd] = useState("");
const [Num, setNum] = useState("");
const [Bairro, setBairro] = useState("");
const [Cidade, setCidade] = useState("");
const [Estado, setEstado] = useState("");
const [NomeEmp, setNomeEmp] = useState("");
const [NomeApp, setNomeApp] = useState("");
const [AppLimit, setAppLimit] = useState(false);
const [TokenMP, setTokenMP] = useState("");
const [KeyMP, setKeyMP] = useState("");
const [WebHookMP, setWebHookMP] = useState("");
const [ReceberMP, setReceberMP] = useState(true);
const [TempAti, setTempAti] = useState(0);
const [Porcen, setPorcen] = useState("");
const [DataP, setDataP] = useState(new Date());
const [VerD, setVerD] = useState(false);
const [DataIni, setDataIni] = useState(0);
const [IdConta, setIdConta] = useState("");
const [Alunos, setAlunos] = useState();
const [ValorTotal, setValorTotal] = useState(0);
const [DataAtual, setDataAtual] = useState();

useEffect(() => {
       
        }, [Alunos, Porcen])

useEffect(() => {

         PreencherFormulario()     
        }, [ListEsp, Porcen ])
useEffect(() => {
      if(Alunos && Porcen){
         CalcularTicket()
        } 
      if(Alunos === 0 && Porcen){
         CalcularTicket()
        }    
        }, [Alunos, Porcen ])
useEffect(() => {
  if(IdConta){
    PegandoValor() 
   }       
    }, [IdConta])

const CalcularTicket = () => {
      
    if(Porcen.AppLimit){
      
      if(Alunos < Porcen.QuantApp){
       
      setValorTotal(Porcen.Mensalidade)
      } else{
        var AppPaga = Alunos - Porcen.QuantApp
        if(AppPaga === 0){
          
          setValorTotal(Porcen.Mensalidade)
        } else{
         
        var MultValor = AppPaga*Porcen.ValorApp
        setValorTotal(Porcen.Mensalidade + MultValor)
        }
       
      }
      
     
     } else{
      console.log(Porcen.Mensalidade)
       setValorTotal(Porcen.Mensalidade)
     }
  } 

const PreencherFormulario = () => {
      setNome(ListEsp.Nome);
      setTelefone(ListEsp.Telefone);
      setDataP(new Date(ListEsp.TempLimitAtiv))
      setIdConta(ListEsp.IdConta)
      setQuantApp(Porcen.QuantApp);
      setValorApp(Porcen.ValorApp);
      setAppLimit(Porcen.AppLimit);
      setMensalidade(Porcen.Mensalidade);
      setDataAtual(ListEsp.TempLimitAtiv);
  } 
  
  
 const handleToggle1 = () => {
    setAppLimit(!AppLimit);
  };
   const handleToggle2 = () => {
    setReceberMP(!ReceberMP);
  };


  const criando = ()=>{

      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
       Api.TAPagarTicketCliente(Id, Nome, Telefone, IdConta, DataAtual, AppLimit,  Mensalidade, QuantApp, ValorApp, Alunos, ValorTotal, UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert);
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    }
   
  const PegandoValor  = ()=>{

      if (navigator.onLine) {
        setMsgErro("")
         
       Api.TAClientesDadosPagar(IdConta, setPorcen, setAlunos);
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    
  }

const AtualizandoData = ()=>{


     if (DataIni !== 0) {
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
       Api.TATualizandoData(Id, DataIni,  UsuariosContServ, setUsuariosContServ, setMsgErro, setLoading, setAlertTipo, setAlert  );
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
      setMsgErro("Escolha Outra Data")
    }
    
  }
  const ColocarImg2 = (e)=>{
    const reader = new FileReader()
    reader.onload = () => {
      if(reader.readyState === 2) {
        setImg2(reader.result);
      }
    }
   reader.readAsDataURL(e.target.files[0]);
    setImgs2(e.target.files[0]);
  }
  const ExcImg2 = ()=>{
   
    setImgs2("");
    setImg2("../assets/avatarimg.png");
  }

  const datando = async (jsDate, dateString)=>{
              
              
              let currentDate = '';
              let now =new Date(jsDate);
              let Dia = now.getDate();
              let Mes = (now.getMonth()+1);
              let Ano = now.getFullYear();
              Dia = Dia < 10 ? '0'+Dia : Dia;
              Mes = Mes < 10 ? '0'+Mes : Mes;
              currentDate = Ano+'-'+Mes+'-'+Dia;
              let Dat  = new Date(currentDate +" 00:00:00.000").getTime();
              console.log(Dat)
              
              
                setDataP(jsDate)
                setDataIni(Dat)

              
             
          }

        return (
            <>
<div className="content-wrapper">
                <Header 
                Titulo={Titulo}
                Avisando={Avisando}
                Fechar={Fechar}
                />
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
            
              <div className="invoice p-3 mb-3">
              {/* title row */}
              <div className="row">
                <div className="col-12">
                  <h4>
                    <i className="far fa-address-card" /> Empresa 
                  </h4>
                </div>
                {/* /.col */}
              </div>
              {/* info row */}
              <div className="row invoice-info">
                <div className="col-sm-4 invoice-col">
                  <address>
                    {Loading  ?
                    <>
                      <Spinner 
                      size={64}
                      color={"#5d0bf7"}
                      sizeUnit={'px'} 
                      /><br />
                      </>
                      :
                      <>
                    
                     {MsgErro !== "" &&
                    <>
                    <div class="alert alert-danger alert-dismissible">
                  
                  <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                  {MsgErro}
                </div>
                   
                    </>
                    }
                    </>
                    }
                    
                 
                       <strong>Data do Vencimento</strong><br />
                       
                          <string>{new Date(ListEsp.TempLimitAtiv).toLocaleDateString('pt-BR')}</string>
                          <br />
                   {ListEsp.Pago &&
                   <>
                    <strong>Data do Pagamento</strong><br />           
                    <string>{new Date(ListEsp.DataPagamento).toLocaleDateString('pt-BR')}</string>
                    <br />
                          </>
                          }
                    <strong>Nome do Cliente</strong><br />
                    <string>{Nome}</string>
                    <br />
                 <strong>Telefone do Cliente</strong><br />
                   <string>{Telefone}</string> 
                    <br />
                 
                     
                  </address>
                    </div>
                      <div className="col-sm-4 invoice-col">
                    <address>
                      {Porcen &&

                      <>
                   <strong style={{fontSize:25}}>Nota de Pagamento </strong><br />
                   <strong>Valor da Mensalidade: </strong>
                   <string>{ListEsp.Mensalidade.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</string><br />
                   {ListEsp.AppLimit ?
                   <>

                   <strong>Valor do App: </strong>
                  <string>{ListEsp.ValorApp.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</string><br /> 
                  <strong>Aplicativos Grátis: </strong>
                  <string>{ListEsp.QuantApp}</string><br /> 
                  <strong>Quantidade de App Ativo: </strong>
                  <string>{ListEsp.Alunos}</string><br /> 
                  
                    </>
                    :
                    <>
                    <strong>Aplicativos Grátis: </strong>
                  <string>Ilimitado</string><br /> 
                    </>
                     }
                     <strong style={{fontSize:20}}>Valor Pago: </strong>
                   <string>{ListEsp.ValorTotal.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</string><br />
                      </>
                  
                      }
                  
                    
                    
                    </address>
                   </div>
                    <div className="col-sm-4 invoice-col">
                    <address>
                     
                 
                    </address>
                   </div>
              </div>
              <div className="row no-print">
              </div>
              
            
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}